/**
 * This is part of the sign-in improvement - Magic link test
 * PRD: https:www.notion.so/faire/Sign-in-flow-b9efea9e78224d9f8c42dccbdb2c95d7
 * @deprecated Remove after FE/mobile usage removed
 */ export var ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024 = 'ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024';
